<script lang="ts" setup>
import { useId } from "vue";
import CheckBox from "../Inputs/CheckBox.vue";

const emit = defineEmits<{ toggleFilter: [] }>();

const props = withDefaults(
  defineProps<{
    isActive: boolean;
    name: string;
    // A disabled option can't be toggled; disabledReason is shown as its tooltip.
    disabled?: boolean;
    disabledReason?: string;
  }>(),
  { disabled: false, disabledReason: "" }
);

const reasonId = useId();

const handleCheckboxChange = () => {
  if (props.disabled) return;
  emit("toggleFilter");
};
</script>

<template>
  <div
    v-tooltip="{ text: disabledReason, disabled: !disabled || !disabledReason, placement: 'cursor-top' }"
    class="ignore-filter-icon-click rounded-4 flex items-center gap-3 px-2 py-1.5 transition-colors"
    :class="disabled ? 'interactive-disabled text-type-muted' : 'text-type-default hover:bg-app-blue-200/20 cursor-pointer'"
    :aria-disabled="disabled || undefined"
    @click="handleCheckboxChange">
    <!-- Disabled: pointer events fall through to the row, which carries the tooltip and ignores clicks. -->
    <div
      :class="{ 'pointer-events-none': disabled }"
      @click.stop>
      <CheckBox
        :value="isActive"
        :aria-label="name"
        :aria-disabled="disabled || undefined"
        :aria-describedby="disabled && disabledReason ? reasonId : undefined"
        size="lg"
        :color="disabled ? 'disabled-child' : 'input'"
        @update:value="handleCheckboxChange" />
    </div>
    <span class="t-small">{{ name }}</span>
    <span
      v-if="disabled && disabledReason"
      :id="reasonId"
      class="sr-only"
      >{{ disabledReason }}</span
    >
  </div>
</template>
